<div class="modal-header">
    <h4 class="modal-title">Add User(s)</h4>
    <button [ladda]="busy" type="button" class="btn cancel" (click)="activeModal.dismiss('cancel')"><i class="fas fa-times"></i></button>
</div>
<div class="modal-body">
    <div class="search" [resizeSearch]>
        <h5>Search</h5>

        <form [formGroup]="searchForm" (ngSubmit)="onSubmit(searchForm)">
            <div class="row">
                <div class="col-sm-12">
                    <div class="form-group">
                        <label class="form-label">Search for User(s)</label>
                        <input type="text" class="form-control" placeholder="Search by name/email address" formControlName="UserSearchProperty"/>
                    </div>
                </div>
            </div>

            <div class="row">
                <div class="col-sm-12">
                    <div>
                        <ngb-accordion [closeOthers]="true" activeIds="ngb-panel-0">
                            <ngb-panel>
                                <ng-template ngbPanelTitle>
                                    PAETEP Buildings ({{ buildings.length }})
                                </ng-template>
                                <ng-template ngbPanelContent>
                                    <ul>
                                        <li *ngFor="let control of buildingOptions.controls">
                                            <label class="form-label">
                                                <input type="checkbox"
                                                       [(ngModel)]="control.value.isChecked"
                                                       [(checklist)]="buildings"
                                                       [ngModelOptions]="{ standalone: true }"
                                                       [value]="control.value.value" /> {{ control.value.name }}
                                            </label>
                                        </li>
                                    </ul>
                                </ng-template>
                            </ngb-panel>
                            <ngb-panel>
                                <ng-template ngbPanelTitle>
                                    PAETEP Roles ({{ roles.length }})
                                </ng-template>
                                <ng-template ngbPanelContent>
                                    <ul>
                                        <li *ngFor="let portalRoleGroup of roleOptions">
                                            {{ portalRoleGroup.label !== '' ? portalRoleGroup.label : 'Misc' }}

                                            <ul>
                                                <li *ngFor="let control of portalRoleGroup.value.controls">
                                                    <label class="form-label">
                                                        <input type="checkbox"
                                                               [(ngModel)]="control.value.isChecked"
                                                               [(checklist)]="roles"
                                                               [ngModelOptions]="{ standalone: true }"
                                                               [value]="control.value.value" /> {{ control.value.name }}
                                                    </label>
                                                </li>
                                            </ul>
                                        </li>
                                    </ul>
                                </ng-template>
                            </ngb-panel>
                            <ngb-panel>
                                <ng-template ngbPanelTitle>
                                    Group ({{ groups.length }})
                                </ng-template>
                                <ng-template ngbPanelContent>
                                    <ul>
                                        <li *ngFor="let control of groupOptions.controls">
                                            <label class="form-label">
                                                <input type="checkbox"
                                                       [(ngModel)]="control.value.isChecked"
                                                       [(checklist)]="groups"
                                                       [ngModelOptions]="{ standalone: true }"
                                                       [value]="control.value.value" /> {{ control.value.name }}
                                            </label>
                                        </li>
                                    </ul>
                                </ng-template>
                            </ngb-panel>
                        </ngb-accordion>
                    </div>
                </div>
            </div>

            <div class="actions">
                <button [ladda]="busy" type="button" class="btn btn-info me-sm-2" (click)="onResetSearch()">Reset</button>
                <button [ladda]="busy" type="button" class="btn btn-secondary me-sm-2" (click)="getAllUsers()">Get All Users</button>
                <button [ladda]="busy" type="submit" class="btn btn-primary">Search</button>
            </div>
        </form>
    </div>
    <div class="results">
        <h5>Results</h5>

        <div class="row">
            <div class="col-sm-12">
                <div class="form-group">
                    <label class="form-label">Search within Results:</label>
                    <input type="text" class="form-control" placeholder="Enter a name or email address here" [(ngModel)]="listFilter" />
                </div>
            </div>
        </div>

        <div class="row">
            <div class="col-sm-12 text-end">
                <label *ngIf="!singleUser" class="form-label"><a href="Javascript://" (click)="onSelectAllUsers()">Add All ({{searchResults.controls.length}})</a></label>
            </div>
        </div>
        <div class="selection-list-container">
            <p *ngIf="searchResults.controls.length === 0">There are currently no users for the selected criteria.</p>

            <ul class="selection-list"
                *ngIf="searchResults.controls.length > 0">
                <li *ngFor="let control of searchResults.controls | userFilter:listFilter"
                    (click)="onSelectUser(control)">
                    {{ control.value.DisplayName }} <i>({{ control.value.Username }})</i> <div class="add" aria-hidden="true" [class.d-none]="singleUser && selectedUsers.controls.length > 0">Add +</div>
                </li>
            </ul>
        </div>
    </div>
    <div class="preview">
        <h5>Roster Preview</h5>

        <button type="button" [ladda]="busy" class="btn btn-success" (click)="activeModal.close(selectedUsers)">Save Roster</button>

        <div class="row">
            <div class="col-sm-8">
                <label class="form-label">The following users will be added to the roster:</label>
            </div>
            <div class="col-sm-4 text-end">
                <label *ngIf="!singleUser" class="form-label"><a href="Javascript://" (click)="onRemoveAllUsers()">Remove All</a></label>
            </div>
        </div>

        <div class="selection-list-container">
            <p *ngIf="selectedUsers.controls.length === 0">There are currently no users selected.</p>

            <ul class="selection-list" *ngIf="selectedUsers.controls.length > 0">
                <li *ngFor="let control of selectedUsers.controls "
                    (click)="onRemoveUser(control)">
                    {{ control.value.DisplayName }} <i [class.d-none]="!control.value.Username">({{ control.value.Username }})</i> <div class="remove" aria-hidden="true">Remove -</div>
                </li>
            </ul>
        </div>
    </div>
</div>